import React from 'react'
import { Router, Switch, Route, useHistory } from 'react-router'
import Layout from './components/Layout'
import MainLayout from './components/MainLayout'
import SignUp from './components/SignUp'
import Counter from './components/Counter'
import FetchData from './components/FetchData'
// import './assets/vendors/style'
import './css/Ant-structure.css'
import './css/Global.css'
import './css/Global-Responsive.css'
import './css/responsive_a.css'
import './custom.css'
import SignIn from './components/SignIn'
import LogInStore from './components/LogInStore'
import AppRoute from './AppRoute'
import App from './containers/App/index'
import { Provider, useDispatch, useSelector } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import PaymentStatus from './components/Payments/PaymentStatus'
import BillingPlans from './routes/Dashboard/BillingPlans'
import StoreRequest from './components/StoreRequest'
import {
  isEmptyObject,
  loadIsOnline,
  apploggedInResp,
  openRegPop,
  storeNamePage,
  userLogOut,
  switchLanguage,
  filterUserByOutlet,
  getDecryptID,
  handleLocalStorage
} from './appRedux/actions'
import { useCookies } from 'react-cookie'
import { env } from './env'
import { checkIsWeb, postDataToApp } from './appRedux/actions/MobAppFn'
import {
  GetAppTypes,
  POS_APP_TYPES,
  PostAppTypes
} from './constants/MobAppConstants'
import languageData, { langDataDB } from './containers/Topbar/languageData'
import SigninLayout from './components/Layouts/SigninLayout'
import { STORE_INFO } from './constants/ActionTypes'
const { TS_COOKIE_BASE_DOMAIN } = env

const MainLayer = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  const urlParams = new URLSearchParams(window.location.search)
  const is_mob_app = urlParams.get('ismobapp')
  // const isMobApp = useSelector(({ commonConfigs }) => commonConfigs.isMobApp)
  const isAppOnline = useSelector(
    ({ commonConfigs }) => commonConfigs.isAppOnline
  )
  // const reduxData = useSelector(state => state)
  const getStoreUsers = useSelector(({ Sell }) => Sell.getStoreUsers)
  const getReduxStoreInfo = useSelector(
    ({ commonConfigs }) => commonConfigs.getStoreInfo
  )
  const [cookies, setCookie] = useCookies(['storeName', 'storeHash', 'reqNo'])

  window.recieveDataFromApp = data => {
    getDataFromApp(data)
  }

  React.useEffect(() => {
    let mounted = true
    if (mounted && is_mob_app) {
      // window.sendDataToApp = data => {
      //   if (window.ReactNativeWebView) {
      //     window.ReactNativeWebView.postMessage(JSON.stringify(data))
      //   }
      // }
      setMobApp(is_mob_app)
      postDataToApp(PostAppTypes.SETUP_DONE, true)
    }
    return () => {
      mounted = false
    }
  }, [is_mob_app])

  // React.useEffect(() => {
  //   const handleStorageChange = (event) => {
  //     console.log('logging local storage ======>')
  //     if (event.key === 'localStorageKey') {
  //      console.log('logging local storage')
  //     }
  //   };

  //   window.addEventListener('storage', handleStorageChange);

  //   return () => {
  //     // Clean up the event listener when the component is unmounted
  //     window.removeEventListener('storage', handleStorageChange);
  //   };
  // }, []);

  function setMobApp (appType) {
    if (appType == POS_APP_TYPES.RETAIL) {
      localStorage.setItem('is_mob_app', `${POS_APP_TYPES.RETAIL}`)
    } else if (appType == POS_APP_TYPES.REPORTING) {
      localStorage.setItem('is_mob_app', `${POS_APP_TYPES.REPORTING}`)
    } else if (appType == POS_APP_TYPES.SCANNER) {
      localStorage.setItem('is_mob_app', `${POS_APP_TYPES.SCANNER}`)
    }
  }

  function getDataFromApp (data) {
    try {
      if (data && !isEmptyObject(data) && data.type) {
        switch (data.type) {
          case GetAppTypes.LOGIN:
            {
              if (data.payload) {
                if (data.payload.platform) {
                  localStorage.setItem('platform_stored', data.payload.platform)
                }
                if (
                  data.payload.storeInfo &&
                  !isEmptyObject(data.payload.storeInfo)
                ) {
                  appUserLoggedIn(data.payload)
                }
                if (
                  data.payload.loginDetails &&
                  !isEmptyObject(data.payload.loginDetails) &&
                  data.payload.appType
                ) {
                  const da = data.payload.loginDetails
                  const body = {
                    data: {
                      data: da
                    }
                  }
                  if (!isEmptyObject(getReduxStoreInfo)) {
                    let userInfo = { ...getReduxStoreInfo }
                    userInfo.roleName = da.roleName
                      ? da.roleName
                      : userInfo.roleName
                    userInfo.userEmail = da.userEmail
                      ? da.userEmail
                      : userInfo.userEmail
                    userInfo.userID = da.userID ? da.userID : userInfo.userID
                    userInfo.userName = da.userName
                      ? da.userName
                      : userInfo.userName
                    if (!isEmptyObject(userInfo)) {
                      dispatch({
                        type: STORE_INFO,
                        payload: userInfo
                      })
                    }
                  }
                  const dataInfo = {
                    outletID:
                      data.payload.switch && data.payload.switch.outletId
                        ? data.payload.switch.outletId
                        : '',
                    registerID:
                      data.payload.switch && data.payload.switch.registerId
                        ? data.payload.switch.registerId
                        : ''
                  }
                  apploggedInResp(
                    body,
                    dispatch,
                    history,
                    false,
                    data.payload.appType,
                    !isEmptyObject(data.payload?.switch),
                    dataInfo
                  )
                } else {
                  dispatch(userLogOut())
                }
              }
            }
            break
          case GetAppTypes.NETWORK:
            {
              // dispatch(loadIsOnline(data.payload ? true : false))
            }
            break
          // case GetAppTypes.LOGOUT:
          //   {
          //     dispatch(userLogOut())
          //   }
          //   break
          case GetAppTypes.ROUTES:
            {
              if (data.payload) {
                history.push(`${data.payload}`)
              }
            }
            break
          case GetAppTypes.REGISTER_POPUP:
            {
              if (data.payload) {
                dispatch(openRegPop())
              }
            }
            break
          case GetAppTypes.LANGUAGE: {
            if (data.payload) {
              const exists =
                langDataDB.filter(a => a.locale == data.payload).length > 0
                  ? langDataDB.filter(a => a.locale == data.payload)[0]
                  : {}
              if (exists && !isEmptyObject(exists)) {
                dispatch(switchLanguage(exists))
              }
            }
            break
          }
          case GetAppTypes.OUTLET_USERS: {
            if (data.payload && getStoreUsers && getStoreUsers.length > 0) {
              const userArray = []
              getStoreUsers.map(user => {
                if (
                  filterUserByOutlet(
                    user.userOutlets,
                    data.payload,
                    getReduxStoreInfo,
                    getDecryptID(user.id)
                  )
                )
                  userArray.push(user)
              })
              if (userArray && userArray.length > 0) {
                postDataToApp(PostAppTypes.OUTLET_USERS, userArray)
              }
            }
            break
          }
          default:
            break
        }
      }
    } catch (ex) {}
  }

  function appUserLoggedIn (data) {
    if (data && !isEmptyObject(data)) {
      const cookieInfo =
        data.storeInfo && !isEmptyObject(data.storeInfo) ? data.storeInfo : {}
      if (!isEmptyObject(cookieInfo)) {
        if (cookieInfo.storeName && cookieInfo.storeHash && cookieInfo.reqNo) {
          setCookie('storeName', cookieInfo.storeName, {
            domain: TS_COOKIE_BASE_DOMAIN,
            path: '/'
          })
          setCookie('storeHash', cookieInfo.storeHash, {
            domain: TS_COOKIE_BASE_DOMAIN,
            path: '/'
          })
          setCookie('reqNo', cookieInfo.reqNo, {
            domain: TS_COOKIE_BASE_DOMAIN,
            path: '/'
          })
          // storeNamePage(cookieInfo.storeName, cookieInfo.storeHash)
          localStorage.setItem('storeName', cookieInfo.storeName)
          localStorage.setItem('storeHash', cookieInfo.storeHash)
          localStorage.setItem('storeReqNo', cookieInfo.reqNo)
        }
      }
    }
  }

  return (
    <ConnectedRouter history={history}>
      <Switch>
        <AppRoute exact path='/' component={SignIn} layout={SigninLayout} />
        <AppRoute exact path='/SignUp' component={SignUp} layout={MainLayout} />
        <AppRoute path='/counter' component={Counter} layout={Layout} />
        <AppRoute
          exact
          path='/SignIn'
          component={SignIn}
          layout={SigninLayout}
        />
        <AppRoute
          exact
          path='/LoginStore'
          component={LogInStore}
          layout={SigninLayout}
        />
        <AppRoute
          path='/fetch-data/:startDateIndex?'
          component={FetchData}
          layout={Layout}
        />
        <Route path='/UserVerify/:token' component={App} />
        <Route path='/dashboard' component={App} />
        <AppRoute
          exact
          path='/payment/status/:storeid/:sessionid'
          component={PaymentStatus}
          layout={Layout}
        />
        <AppRoute
          exact
          path='/billing/:tokenLess'
          component={BillingPlans}
          layout={Layout}
          tokenLess={true}
        />
        <AppRoute
          exact
          path='/store/request/:noOfOutlet/:noOfReg/:id/:periodFreq'
          component={StoreRequest}
          layout={Layout}
        />
      </Switch>
    </ConnectedRouter>
  )
}

export default MainLayer
